import { EndpointType } from "../../constants/Endpoints";
import { OacJsonResponse } from "../../types/demo";
import { ExtractorOacJsonResponse } from "../../types/extractorOacResponse";
import { LAOacJsonResponse } from "../../types/laOacResponse";
import { OCROacJsonResponse } from "../../types/ocrOacResponse";
import { FileUploadCallbacks } from "../../types/upload";

export const createDefaultCallbacks = (): FileUploadCallbacks => ({
  setSelectedFileIndex: () => {},
  setFiles: () => {},
  setInferenceState: () => {},
  setIsOpen: () => {},
  setWorkPercentageVisible: () => {},
  setErrorOn: () => {},
  setErrorType: () => {},
  setErrorCloseFunction: () => {},
  setErrorReloadFunction: () => {},
});

export const delay = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const castResponseByEndpointType = (
  responseData: any,
  endpointType: EndpointType,
): OacJsonResponse => {
  switch (endpointType) {
    case "extractor":
      return responseData as ExtractorOacJsonResponse;
    case "ocr":
      return responseData as OCROacJsonResponse;
    case "layout-analysis":
      return responseData as LAOacJsonResponse;
    default:
      console.warn(
        `Unknown endpointType: ${endpointType}, returning as OacJsonResponse`,
      );
      throw new Error("Unknown endpointType");
  }
};
